export default __webpack_public_path__ + "static/media/apple.f24c8b8b.png";